/**
 * The guide's version (part 11b, table V, the user's choice 2026-10-07: the help opens by itself again when the guide
 * changes): a hash of the guide's Markdown as the writer's language writes it. Not a security check; it only has to
 * change when the text does.
 */

/** Eight hexadecimal digits: FNV-1a over the text's UTF-16 code units. */
export function guideVersion(text: string): string {
  let hash = 0x811c9dc5;
  for (let at = 0; at < text.length; at++) hash = Math.imul(hash ^ text.charCodeAt(at), 0x01000193) >>> 0;
  return hash.toString(16).padStart(8, '0');
}

/** Whether a stored value is a guide version (G4: anything else reads as none, V4). */
export function isGuideVersion(value: unknown): value is string {
  return typeof value === 'string' && /^[0-9a-f]{8}$/u.test(value);
}
